module.exports = __webpack_public_path__ + "img/first_trophy.d0c7966c.svg";